import React, { useState } from 'react';
import ContactModal from './ContactModal';

const Hero = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <section className="relative overflow-hidden bg-[#3f9422]">
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="h-full w-full object-cover"
        >
          <source src="/videos/snow_blowing.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-gradient-to-r from-[#3f9422]/80 via-[#3f9422]/40 to-[#3f9422]/30" />
      </div>

      <div className="relative z-10 mx-auto flex min-h-[280px] w-full max-w-7xl items-center px-4 py-12 md:min-h-[360px] md:px-6 md:py-20">
        <div className="flex w-full max-w-3xl flex-col items-start text-left">
          <h1 className="title-font mb-6 text-4xl font-black leading-tight text-white drop-shadow-md sm:text-2xl md:text-3xl">
            Prime Lawn & Snow Management
          </h1>

          <div className="flex justify-start">
            <button
              onClick={() => setShowForm(true)}
              className="btn-primary rounded-lg border-0 px-8 py-3 text-lg font-semibold text-white shadow-lg focus:outline-none"
            >
              Contact Now
            </button>
          </div>
        </div>
      </div>

      <ContactModal isOpen={showForm} onClose={() => setShowForm(false)} />
    </section>
  );
};

export default Hero;